import { render } from "./image-header.vue?vue&type=template&id=4f00aef1&lang=pug"
import script from "./image-header.vue?vue&type=script&lang=js"
export * from "./image-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__